import React from 'react';

const SummaryCardItem = ({ title, children }: { title: string; children: React.ReactNode }) => (
    <div className="card-summary-list__item">
        <div className="heading heading--h5">{title}</div>
        <div className="paragraph paragraph--soft paragraph--no-margin">{children}</div>
    </div>
);

export default SummaryCardItem;
